import Vue from 'vue'

export function useChatSocket(url) {
    const state = Vue.observable({
        socket: null,
        messages: [],
        isManualClose: false,
        reconnectTimer: null,
        heartbeatTimer: null
    })

    const reconnectInterval = 5000
    const heartbeatInterval = 10000

    /** 连接 WebSocket */
    const connect = () => {
        if (state.socket || state.isManualClose) return

        state.socket = new WebSocket(url)

        state.socket.onopen = () => {
            console.log('[WebSocket] 连接成功')
            startHeartbeat()
        }

        state.socket.onmessage = event => {
            try {
                const data = JSON.parse(event.data)
                if (data.code === '0') return // 心跳响应
                state.messages.push(data)
            } catch (e) {
                console.warn('[WebSocket] 接收非 JSON 消息：', event.data)
            }
        }

        state.socket.onclose = () => {
            console.warn('[WebSocket] 连接关闭')
            cleanup()
            if (!state.isManualClose) {
                state.reconnectTimer = setTimeout(() => {
                    console.log('[WebSocket] 尝试重连...')
                    connect()
                }, reconnectInterval)
            }
        }

        state.socket.onerror = err => {
            console.error('[WebSocket] 错误', err)
            state.socket && state.socket.close()
        }
    }

    /** 发送消息 */
    const sendMessage = (msg) => {
        if (state.socket && state.socket.readyState === WebSocket.OPEN) {
            state.socket.send(msg)
        }
    }

    /** 主动断开连接 */
    const disconnect = () => {
        state.isManualClose = true
        cleanup()
        if (state.socket) {
            state.socket.close()
            state.socket = null
        }
    }

    /** 启动心跳 */
    const startHeartbeat = () => {
        stopHeartbeat()
        state.heartbeatTimer = setInterval(() => {
            if (state.socket && state.socket.readyState === WebSocket.OPEN) {
                state.socket.send(JSON.stringify({ code: '0' }))
            }
        }, heartbeatInterval)
    }

    /** 停止心跳 */
    const stopHeartbeat = () => {
        if (state.heartbeatTimer) {
            clearInterval(state.heartbeatTimer)
            state.heartbeatTimer = null
        }
    }

    /** 清理定时器 */
    const cleanup = () => {
        if (state.reconnectTimer) {
            clearTimeout(state.reconnectTimer)
            state.reconnectTimer = null
        }
        stopHeartbeat()
    }

    return {
        connect,
        disconnect,
        sendMessage,
        state
    }
}
